import React,{useState} from "react";
import { ethers,utils } from "ethers";
import {getProvider} from "./../Navbars/WalletConnector";
import CardStats from "components/Cards/CardStats.js";

export default function HeaderStats() {
  function convert(bigNumber, unit="ether"){
    if(typeof bigNumber !== "object") return bigNumber;
    return utils.formatUnits(bigNumber.toString(),unit);

  }
  

  
  const [supply,setSupply]=useState();
  const [supplyX,setSupplyX]=useState();

  const Supplyaddress = "0x6364c250a26f171e05b9D26b66baB17921eC72b9";
  const SupplyaddressX = "0x0946DDfa783d130438FE43489580aC7e9415dD17";
const Supplyabi = [
  "function totalSupply() view returns (uint256)"
];


  async function totalSupply() {
    const provider = await getProvider()
  const signer = provider.getSigner()
    const contract = new ethers.Contract(Supplyaddress, Supplyabi, signer);   
    const result = await contract.functions.totalSupply();
    let nf = new Intl.NumberFormat('en-US');

    setSupply(nf.format(parseInt(convert(result[0]))*1000000000))
  }

  async function totalSupplyX() {
    const provider = await getProvider()
    const signer = provider.getSigner()
    const contract = new ethers.Contract(SupplyaddressX, Supplyabi, signer);   
    const result = await contract.functions.totalSupply();
    let nf = new Intl.NumberFormat('en-US');

    setSupplyX(nf.format(parseInt(convert(result[0]))))
  }
  
  totalSupply();
  totalSupplyX();
  return (
    <>
      {/* Header */}
      <div style={{"backgroundImage":`url("https://metaflokiavatars.com/wp-content/uploads/2021/12/18.jpg")`,
       "backgroundSize": "cover",
        "backgroundPosition": "top center",
         "backgroundRepeat": "no-repeat",
         marginTop:"150px",
         paddingTop:"30px"}} className="relative my-Font bg-lightBlue-600 md:pt-32 pb-32  ">
        <div className="px-4 md:px-10 mx-auto w-full">
          <div>
            {/* Card stats */}
            <div className="flex flex-wrap w-full">
             
             
              <div  className=" px-4 my-4 w-full ">
                <CardStats
                  statSubtitle="Total  Supply Avatars"
                  statTitle={supply}
                  statArrow=""
                  statPercent=""
                  statPercentColor=""
                  statDescripiron=""
                  statIconName="fas fa-percent"
                  statIconColor="bg-lightBlue-500"
                />
              </div>
              <div  className=" px-4 my-4 w-full ">
                <CardStats
                  statSubtitle="Total  Supply XMFA"
                  statTitle={supplyX}
                  statArrow=""
                  statPercent=""
                  statPercentColor=""
                  statDescripiron=""
                  statIconName="fas fa-percent"
                  statIconColor="bg-lightBlue-500"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
